import {
  SET_DATAGUARD_HEADER_DATA,
  SET_DATAGUARD_HEATMAP_DATA,
  SET_DATAGUARD_ROLES_DATA,
  SET_DATAGUARD_BEHAVIOR_DATA,
  SET_DATAGUARD_FROM_TIME_STAMP,
  SET_DATAGUARD_TO_TIME_STAMP,
  SET_LOCATION_SUMMARY,
  SET_DATAGUARD_INCOGNITO,
  SET_KEY_DOC_OWNER_DATA,
  SET_NOTIFICATION_UPDATE_STATUS,
  SET_REVOKE_ACCESS_UPDATE_STATUS,
  SET_DATA_GUARD_LOCATION_FILTERS,
  SET_DATA_GUARD_SELECTED_LOCATION_FILTERS,
  CLEAR_DATA_GUARD_FILTERS,
  SET_DATA_GUARD_POLICY_SUBTYPE_FILTERS,
  SET_DATA_GUARD_SELECTED_POLICY_SUBTYPE_FILTERS,
  SET_DATA_GUARD_SEVERITY_FILTERS,
  SET_DATA_GUARD_SELECTED_SEVERITY_FILTERS,
  SET_DATA_GUARD_SELECTED_OWNERS_FILTERS,
  SET_DATA_GUARD_OWNERS_FILTERS,
  SET_DATA_GUARD_SELECTED_USER_ROLES_FILTERS,
  SET_DATA_GUARD_USER_ROLES_FILTERS,
  SET_DISPLAY_ALERT_COMMENT,
  SET_DATA_GUARD_ALERT_COMMENT,
  DISPLAY_DATA_GUARD_ALERT_COMMENT,
  SET_DATA_GUARD_ALERT_STATUS,
  OPEN_DATA_GUARD_SNACKBAR,
  SET_DATA_GUARD_REPORT_INCIDENT_DATA,
  DATA_GUARD_REPORT_INCIDENT_SUCCESSFUL,
  DATA_GUARD_REPORT_INCIDENT_FAILED,
  SET_DATA_GUARD_REPORT_INCIDENT_DETAILS,
  UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD,
  UPDATE_ALERT_STATUS_FAILED_DATAGUARD,
  ALERT_ACTION_SUCCESS_DATAGUARD,
  ALERT_ACTION_FAILED_DATAGUARD,
  SET_CITY_LEVEL_DATA,
  SET_CITY_LEVEL_LOADER,
  SET_DATA_GUARD_USERS_FILTER_LIST,
  SET_DATA_GUARD_SELECTED_USERS_FILTERS,
} from "../Utility/DataguardConstant";
import {
  SET_POPUP_DATA,
  SET_POPUP_OPEN,
  SET_POPUP_LOADER,
  SET_POPUP_PAGINATION,
  SET_POPUP_AGGREGATION_DATA,
  CLOSE_POPUP,
} from "../Popup/ActionTypes";
import { defineds } from "../../../components/common/Navbar/AppDateTimeRange";

const initialState = {
  dataguardHeaderData: null,
  locationSummary: null,
  heatmapData: null,
  totalAssetsCount: 0,
  keyDocOwnerData: [],
  rolesData: {},
  behaviorData: {},
  fromTimeStamp: defineds.startOfLastSevenDay.getTime(),
  toTimeStamp: defineds.endOfToday.getTime(),
  headerLoader: false,
  locationSummaryLoader: false,
  heatmapLoader: false,
  keyDocOwnerLoader: false,
  rolesLoader: false,
  behaviorLoader: false,
  incognito: true,
  // Popup related state
  popupData: null,
  popupOpen: false,
  popupLoader: false,
  popupType: null,
  popupPagination: { page: 0, pageSize: 10 },
  popupAggregationData: null,
  notificationUpdateStatus: false,
  revokeAccessUpdateStatus: false,
  locationFiltersList: [],
  selectedLocationFiltersList: [],
  policySubtypeFiltersList: [],
  selectedPolicySubtypeFiltersList: [],
  severityFiltersList: [],
  selectedSeverityFiltersList: [],
  userRolesFiltersList: [],
  selectedUserRolesFiltersList: [],
  ownersFiltersList: [],
  selectedOwnersFiltersList: [],
  displayAlertComment: false,
  alertComment: null,
  alertStatus: null,
  openDataGuardSnackBar: false,
  reportIncidentData: [],
  alertStatusUpdateSuccess: false,
  alertStatusSuccessMessage: null,
  alertStatusFailedMessage: null,
  cityLevelDataByCountry: {},
  cityLevelLoader: false,
   usersFiltersList: [],
};

const DataguardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_HEADER_LOADER": {
      return {
        ...state,
        headerLoader: action.payload,
      };
    }
    case SET_DATA_GUARD_ALERT_COMMENT: {
      return {
        ...state,
        alertComment: action.payload,
      };
    }
    case DISPLAY_DATA_GUARD_ALERT_COMMENT: {
      return {
        ...state,
        displayAlertComment: action.payload,
      };
    }
    case SET_DATA_GUARD_ALERT_STATUS: {
      return {
        ...state,
        alertStatus: action.payload,
      };
    }
    case OPEN_DATA_GUARD_SNACKBAR: {
      return {
        ...state,
        openDataGuardSnackBar: action.payload,
      };
    }
    case SET_DATA_GUARD_REPORT_INCIDENT_DATA: {
      return {
        ...state,
        reportIncidentData: action.payload,
      };
    }
    case SET_DATA_GUARD_REPORT_INCIDENT_DETAILS: {
      return {
        ...state,
        reportIncidentData: action.payload,
      };
    }
    case DATA_GUARD_REPORT_INCIDENT_SUCCESSFUL: {
      return {
        ...state,
      };
    }
    case DATA_GUARD_REPORT_INCIDENT_FAILED: {
      return {
        ...state,
      };
    }
    case "SET_HEADER_LOADER": {
      return {
        ...state,
        locationSummaryLoader: action.payload,
      };
    }
    case "SET_HEATMAP_LOADER": {
      return {
        ...state,
        heatmapLoader: action.payload,
      };
    }
    case "SET_ROLES_LOADER": {
      return {
        ...state,
        rolesLoader: action.payload,
      };
    }
    case "SET_BEHAVIOR_LOADER": {
      return {
        ...state,
        behaviorLoader: action.payload,
      };
    }
    case "SET_KEY_DOC_OWNER_LOADER": {
      return {
        ...state,
        keyDocOwnerLoader: action.payload,
      };
    }
    case SET_LOCATION_SUMMARY: {
      return {
        ...state,
        locationSummary: action.payload,
      };
    }
    case SET_DATA_GUARD_USERS_FILTER_LIST:
      return { ...state, usersFiltersList: action.payload };
    case SET_DATA_GUARD_SELECTED_USERS_FILTERS:
      return { ...state, selectedUsersFiltersList: action.payload };
    case SET_DATAGUARD_INCOGNITO: {
      return {
        ...state,
        incognito: action.payload,
      };
    }
    case SET_DATAGUARD_HEADER_DATA: {
      return {
        ...state,
        dataguardHeaderData: action.payload,
      };
    }
    case SET_DATAGUARD_HEATMAP_DATA: {
      return {
        ...state,
        heatmapData: action.payload.heatmapData,
        totalAssetsCount: action.payload.totalAssetsCount,
      };
    }
    case SET_DATAGUARD_ROLES_DATA: {
      return {
        ...state,
        rolesData: action.payload,
      };
    }
    case SET_DATAGUARD_BEHAVIOR_DATA: {
      return {
        ...state,
        behaviorData: action.payload,
      };
    }
    case SET_KEY_DOC_OWNER_DATA: {
      return {
        ...state,
        keyDocOwnerData: action.payload,
      };
    }
    case SET_DATAGUARD_FROM_TIME_STAMP: {
      return {
        ...state,
        fromTimeStamp: action.payload,
      };
    }
    case SET_DATAGUARD_TO_TIME_STAMP: {
      return {
        ...state,
        toTimeStamp: action.payload,
      };
    }
    case SET_POPUP_DATA: {
      return {
        ...state,
        popupData: action.payload.data,
      };
    }
    case SET_POPUP_OPEN: {
      return {
        ...state,
        popupOpen: action.payload.open,
        popupDetails: action.payload.popupDetails,
      };
    }
    case SET_POPUP_LOADER: {
      return {
        ...state,
        popupLoader: action.payload,
      };
    }
    case SET_NOTIFICATION_UPDATE_STATUS: {
      return {
        ...state,
        notificationUpdateStatus: action.payload,
      };
    }
    case SET_REVOKE_ACCESS_UPDATE_STATUS: {
      return {
        ...state,
        revokeAccessUpdateStatus: action.payload,
      };
    }
    case SET_DATA_GUARD_LOCATION_FILTERS: {
      return {
        ...state,
        locationFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_SELECTED_LOCATION_FILTERS: {
      return {
        ...state,
        selectedLocationFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_POLICY_SUBTYPE_FILTERS: {
      return {
        ...state,
        policySubtypeFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_SELECTED_POLICY_SUBTYPE_FILTERS: {
      return {
        ...state,
        selectedPolicySubtypeFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_SEVERITY_FILTERS: {
      return {
        ...state,
        severityFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_SELECTED_SEVERITY_FILTERS: {
      return {
        ...state,
        selectedSeverityFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_USER_ROLES_FILTERS: {
      return {
        ...state,
        userRolesFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_SELECTED_USER_ROLES_FILTERS: {
      return {
        ...state,
        selectedUserRolesFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_OWNERS_FILTERS: {
      return {
        ...state,
        ownersFiltersList: action.payload,
      };
    }
    case SET_DATA_GUARD_SELECTED_OWNERS_FILTERS: {
      return {
        ...state,
        selectedOwnersFiltersList: action.payload,
      };
    }
    case SET_CITY_LEVEL_DATA:
      return {
        ...state,
        cityLevelDataByCountry: {
          ...state.cityLevelDataByCountry,
          [action.payload.country]: action.payload.data,
        },
      };
    case SET_CITY_LEVEL_LOADER: {
      return {
        ...state,
        cityLevelLoader: action.payloads,
      };
    }
    case CLEAR_DATA_GUARD_FILTERS: {
      return {
        ...state,
        selectedLocationFiltersList: [],
        selectedPolicySubtypeFiltersList: [],
        selectedSeverityFiltersList: [],
        selectedUserRolesFiltersList: [],
        selectedOwnersFiltersList: [],
        selectedUsersFiltersList: [],
        usersFiltersList: [],
      };
    }
    case SET_POPUP_PAGINATION: {
      return {
        ...state,
        popupPagination: action.payload,
      };
    }
    case SET_POPUP_AGGREGATION_DATA: {
      return {
        ...state,
        popupAggregationData: action.payload,
      };
    }
    case CLOSE_POPUP: {
      return {
        ...state,
        popupOpen: false,
        popupData: null,
        popupType: null,
        popupLoader: false,
        popupAggregationData: null,
        popupPagination: { page: 0, pageSize: 10 }, // Reset pagination when closing
      };
    }
    case UPDATE_ALERT_STATUS_SUCCESS_DATAGUARD: {
      return {
        ...state,
        alertStatusUpdateSuccess: true,
        alertStatusSuccessMessage: action.payload,
      };
    }
    case UPDATE_ALERT_STATUS_FAILED_DATAGUARD: {
      return {
        ...state,
        alertStatusUpdateSuccess: false,
        alertStatusFailedMessage: action.payload,
      };
    }
    case ALERT_ACTION_SUCCESS_DATAGUARD: {
      return {
        ...state,
        alertStatusUpdateSuccess: true,
        alertStatusSuccessMessage: action.payload,
      };
    }
    case ALERT_ACTION_FAILED_DATAGUARD: {
      return {
        ...state,
        alertStatusUpdateSuccess: false,
        alertStatusFailedMessage: action.payload,
      };
    }
    default:
      return state;
  }
};

export default DataguardReducer;